module.exports = __webpack_public_path__ + "img/header-memoireRingsConfigurator.1e70ffe.jpg";